import CloseButton from 'Components/Common/CloseButton';
import RadioGroup from 'Components/input/RadioGroup/RadioGroup';
import React, { useEffect, useState } from 'react';
import { Offcanvas, OffcanvasBody } from 'reactstrap';
import {
    CreatorDmSessionFilters,
    defaultCreatorDmSessionFilters,
} from 'types/creator-dm';

interface CreatorDMFiltersProps {
    isOpen: boolean;
    onClose: () => void;
    defaultFilters: CreatorDmSessionFilters;
    onApply: (filters: CreatorDmSessionFilters) => void;
}

const STATUS_OPTIONS = [
    { id: 'all', label: 'All' },
    { id: 'ongoing', label: 'Ongoing' },
    { id: 'complete', label: 'Complete' },
];

const CREATOR_RESPONDED_OPTIONS = [
    { id: 'all', label: 'All' },
    { id: 'y', label: 'Yes' },
    { id: 'n', label: 'No' },
];

const CONTROL_OPTIONS = [
    { id: 'all', label: 'All' },
    { id: 'human', label: 'Human' },
    { id: 'agent', label: 'Agent' },
];

const toTileValue = (value?: string) => (value ? value : 'all');

const CreatorDMFilters: React.FC<CreatorDMFiltersProps> = ({
    isOpen,
    onClose,
    defaultFilters,
    onApply,
}) => {
    const [filters, setFilters] = useState<CreatorDmSessionFilters>(defaultFilters);

    useEffect(() => {
        setFilters(defaultFilters);
    }, [defaultFilters, isOpen]);

    const applyFilters = (next: CreatorDmSessionFilters) => {
        onApply({
            status: next.status === 'all' || !next.status ? '' : next.status,
            creator_responded:
                next.creator_responded === 'all' || !next.creator_responded
                    ? ''
                    : next.creator_responded,
            control: next.control === 'all' || !next.control ? '' : next.control,
        });
        onClose();
    };

    return (
        <Offcanvas isOpen={isOpen} toggle={onClose} direction="end">
            <CloseButton onClose={onClose} />
            <OffcanvasBody className="p-0 position-relative">
                <div className="payments-offcanvas-bg" />
                <div className="filters p-4">
                    <div className="form-group filter-item">
                        <label htmlFor="creator-dm-status" className="filter-label">
                            Status
                        </label>
                        <RadioGroup
                            name="creator-dm-status"
                            options={STATUS_OPTIONS}
                            defaultValue={toTileValue(filters.status)}
                            onChange={(status) =>
                                setFilters({
                                    ...filters,
                                    status: status as CreatorDmSessionFilters['status'],
                                })
                            }
                            selectFirstWhenNoValueProvided={false}
                        />
                    </div>
                    <div className="form-group filter-item">
                        <label htmlFor="creator-dm-responded" className="filter-label">
                            Creator responded?
                        </label>
                        <RadioGroup
                            name="creator-dm-responded"
                            options={CREATOR_RESPONDED_OPTIONS}
                            defaultValue={toTileValue(filters.creator_responded)}
                            onChange={(creator_responded) =>
                                setFilters({
                                    ...filters,
                                    creator_responded:
                                        creator_responded as CreatorDmSessionFilters['creator_responded'],
                                })
                            }
                            selectFirstWhenNoValueProvided={false}
                        />
                    </div>
                    <div className="form-group filter-item">
                        <label htmlFor="creator-dm-control" className="filter-label">
                            Control
                        </label>
                        <RadioGroup
                            name="creator-dm-control"
                            options={CONTROL_OPTIONS}
                            defaultValue={toTileValue(filters.control)}
                            onChange={(control) =>
                                setFilters({
                                    ...filters,
                                    control: control as CreatorDmSessionFilters['control'],
                                })
                            }
                            selectFirstWhenNoValueProvided={false}
                        />
                    </div>
                </div>
                <div className="filters-offcanvas-footer d-flex justify-content-between align-items-center px-3 p-4 gap-2">
                    <button
                        type="button"
                        className="theme-btn theme-btn-lg w-100 btn-primary-outlined"
                        onClick={() => applyFilters({ ...defaultCreatorDmSessionFilters })}
                    >
                        Reset
                    </button>
                    <button
                        type="button"
                        className="theme-btn theme-btn-lg w-100 btn-primary"
                        onClick={() => applyFilters(filters)}
                    >
                        Apply
                    </button>
                </div>
            </OffcanvasBody>
        </Offcanvas>
    );
};

export default CreatorDMFilters;
